import { create } from 'zustand'

interface IActiveCourseContentState {
  activeLessonId: number | string
  setActiveLessonId: (id: number | string) => void
}

export const useActiveCourseContentStore = create<IActiveCourseContentState>(
  (set) => ({
    activeLessonId: 0,
    setActiveLessonId: (id) => set({ activeLessonId: id }),
  }),
)
